<template>
    <div></div>
</template>

<script>
    export default {
        name: 'ZygoteOption'
    }
</script>

<style lang="less">
    @import "~@/assets/less/variables";
</style>
